import { render, staticRenderFns } from "./ComponentOrderSearch.vue?vue&type=template&id=a3cb5948"
import script from "./ComponentOrderSearch.vue?vue&type=script&lang=js"
export * from "./ComponentOrderSearch.vue?vue&type=script&lang=js"
import style0 from "./ComponentOrderSearch.vue?vue&type=style&index=0&id=a3cb5948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports